import { intervalToDuration } from 'date-fns'
import i18next from 'i18next'

export const formatDuration = (durationMilliseconds: number, useShorthandFormat?: boolean): string => {
  const { days, hours, minutes, seconds } = intervalToDuration({
    start: 0,
    end: durationMilliseconds,
  })

  if (days) {
    // format: 1d 21h 3m 43s, if is extra small screen remove seconds: 1d 21h 3m
    return useShorthandFormat
      ? i18next.t('common.format.timePreciseShorthandSecondsOmitted', { days: days, hours: hours ?? 0, mins: minutes ?? 0 })
      : i18next.t('common.format.timePreciseShorthandDaysIncluded', { days: days, hours: hours ?? 0, mins: minutes ?? 0, sec: seconds ?? 0 })
  }

  // format: 0h 3m 43s
  return i18next.t('common.format.timePreciseShorthand', { hours: hours ?? 0, mins: minutes ?? 0, sec: seconds ?? 0 })
}
